import api from './api';

export const referralAPI = {
  getStats: () => api.get('/referral/me'),
  logShare: (platform: 'whatsapp' | 'email' | 'facebook') =>
    api.post('/referral/share', { platform }),
  claimReward: () => api.post('/referral/claim-reward'),
  getLeaderboard: () => api.get('/referral/leaderboard'),
};
